const HOUR = 3600;
const MINUTE = 60;
const KILO_METER = 1000;

const TIME_MATCHER = /^(2[0-3]|[01]?[0-9]):?([0-5]?[0-9])?$/;
const DURATION_MATCHER =
  /^(?:([0-9]{1,3})h(?:([0-5]?[0-9])m?)?|([0-5]?[0-9])m|([0-9]{1,3}))$/;
const DISTANCE_MATCHER =
  /^(?:([0-9]{1,3}(?:\.[0-9]{1,3})?)(?:k|km)?|([0-9]{1,6})m)$/;
const COUNT_MATCHER = /^([0-9]+[0-9,]*)(?![0-9.,])/;
const COUNT_PER_AREA_MATCHER =
  /^([0-9]+[0-9,]*(?:\.[0-9]+)?(?:[eE][+-]?[0-9]+)?)(?![0-9.,eE+-])/;

const parseTime = (value: string): number | null => {
  if (!value) {
    return null;
  }
  const match = value.match(TIME_MATCHER);
  if (!match) {
    return null;
  }
  const hours = Number(match[1]);
  const minutes = Number(match[2] || '0');
  return hours * HOUR + minutes * MINUTE;
};

const parseDuration = (value: string): number | null => {
  if (!value) {
    return null;
  }
  const match = value.match(DURATION_MATCHER);
  if (!match) {
    return null;
  }
  const hours = (match[1] ?? match[4]) ? Number(match[1] ?? match[4]) : 0;
  const minutes = (match[2] ?? match[3]) ? Number(match[2] ?? match[3]) : 0;
  return hours * HOUR + minutes * MINUTE;
};

const parseDistance = (value: string): number | null => {
  if (!value) {
    return null;
  }
  const match = value.match(DISTANCE_MATCHER);
  if (!match) {
    return null;
  }
  return match[1] ? Number(match[1]) * KILO_METER : Number(match[2]);
};

const parseCount = (value: string): number | null => {
  if (!value) {
    return null;
  }
  const match = value.match(COUNT_MATCHER);
  if (!match) {
    return null;
  }
  return Number(match[1].replaceAll(',', ''));
};

const parseCountPerArea = (value: string): number | null => {
  if (!value) {
    return null;
  }
  const match = value.match(COUNT_PER_AREA_MATCHER);
  if (!match) {
    return null;
  }
  return Number(match[1].replaceAll(',', ''));
};

const parseAny = (
  type: 'time' | 'duration' | 'distance' | 'count' | 'countPerArea',
  value: string
): number | null => {
  switch (type) {
    case 'time':
      return parseTime(value);
    case 'duration':
      return parseDuration(value);
    case 'distance':
      return parseDistance(value);
    case 'count':
      return parseCount(value);
    case 'countPerArea':
      return parseCountPerArea(value);
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export {
  parseTime,
  parseDuration,
  parseDistance,
  parseCount,
  parseCountPerArea,
  parseAny,
};
